import React from 'react'
import Footer from '../components/global/Footer';
import NavbarBottom from '../components/global/NavbarBottom';
import SolutionsChildContent from '../components/SolutionsChild/SolutionsChildContent';
import NavbarTopSolution from '../components/global/NavbarTopSolution';


const SolutionsChild = (props) => {
    return (
        <>
            <NavbarTopSolution/>
            <SolutionsChildContent id={props.id}/>
            <Footer/>
            <NavbarBottom/>
        </>
    )
}

export default SolutionsChild